var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.03 148.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4f4f4;\n      }\n\n      .cls-2 {\n        fill: #8b6a4f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3.56,
    y: -4.69,
    width: 495.99,
    height: 157.41
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.62,
    y: 50.33,
    width: 4.43,
    height: 28.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.88 74.7 67.26 50.33 60.97 50.33 60.97 78.6 64.95 78.6 64.95 54.32 79.49 78.6 85.96 78.6 85.96 50.33 81.88 50.33 81.88 74.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.51,71.33c0-4.79-2.84-7.09-10.19-9.13-5.76-1.59-7.27-2.92-7.27-5.32s2.48-3.63,6.29-3.63c3.46,0,7.09.89,10.28,2.13l-.62-4.25c-3.46-1.06-6.38-1.51-9.66-1.51-7.09,0-10.81,3.1-10.81,7.53,0,4.61,2.75,7,9.92,8.95,5.85,1.51,7.53,2.75,7.53,5.49s-2.3,4.17-7,4.17c-3.37,0-7.09-.8-10.72-2.22l.71,4.16c2.22.71,5.58,1.68,10.37,1.68,7.27,0,11.17-3.19,11.17-8.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.19,
    y: 50.33,
    width: 4.43,
    height: 28.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "158.66 75.06 158.66 65.93 171.25 65.93 171.25 62.38 154.23 62.38 154.23 78.6 174.88 78.6 175.41 75.06 158.66 75.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.14 53.97 142.31 53.97 142.31 78.6 137.88 78.6 137.88 53.97 128.31 53.97 128.84 50.33 174.7 50.33 175.14 53.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.77,
    y: 89.32,
    width: 1.56,
    height: 9.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.35 97.87 59.21 89.32 57 89.32 57 99.25 58.41 99.25 58.41 90.71 63.52 99.25 65.77 99.25 65.77 89.32 64.35 89.32 64.35 97.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.69 90.58 77.51 89.32 70.46 89.32 70.46 99.25 72 99.25 72 95.45 76.57 95.45 76.57 94.21 72 94.21 72 90.58 77.69 90.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.46,92.3c0-1.87-1.18-2.98-3.56-2.98h-4.3s0,9.92,0,9.92h1.56s0-3.93,0-3.93h2.14s2.93,3.93,2.93,3.93h1.87s-3.2-4.12-3.2-4.12c1.69-.36,2.57-1.42,2.57-2.82ZM83.12,94.09v-3.51h2.57c1.48,0,2.21.58,2.21,1.74s-.84,1.78-2.32,1.78h-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.14,89.32l-4.24,9.92h1.58s.91-2.23.91-2.23h4.9s.9,2.23.9,2.23h1.66s-4.14-9.92-4.14-9.92h-1.57ZM95.87,95.82l1.99-4.86,1.96,4.86h-3.95Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.88 95.05 113.51 95.05 113.51 93.45 174.6 93.45 174.88 95.05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/Type.0dbecf8ac3ae7c84bf7a0ef9b4cc196b.svg";
export { ForwardRef as ReactComponent };